<template>
  <div>
    <!-- 头部 -->
    <top></top>
    <div class="main">
      <navMenu :active="active"></navMenu>
      <div class="content badge-content" v-loading.lock="loading">
        <div class="go-back" @click="goBack">返回</div>
        <div class="badge-tips">
          <p>为客户申请观众胸卡（截止日期：2024年10月28日）</p>
          <p>1.参展商可通过填写此表为您的客户申请特邀观众胸卡。</p>
          <p>
            2.主办方将对申请信息进行审核，参展商本企业人员将无法获得特邀观众资格
          </p>
          <p>
            3.请确保各项信息准确填写，提交成功后，组委会将发送确认短信到您客户的手机，通知其到访您的展位（<span
              class="red"
              >如手机号错误</span
            >，您的客户将无法收到短信，且无法获得参观凭证）
          </p>
          <p>
            4.我们将为您邀请的客户制作“特邀观众”实名胸卡，凭此胸卡可快速入场，并可进入药交会VIP休息区
          </p>
          <p>
            5.特邀观众与展商胸卡，在5月14日展商报到时领取（入场需实名认证，展前我们将短信通知您邀请的客户进入系统补录身份证信息）
          </p>
          <p>
            6.您于4月15日后申请的客户胸卡，我们将通知您的客户，于5月15-17日至展会现场自助打印领取
          </p>
          <br />
          <p class="red">重要提示：</p>
          <p class="red">
            1、往届您邀请的客户，如本届再次邀请，请先逐个勾选ID前的勾选框，点击列表下方的“批量设定客户”，完成后系统会触发通知短信。同时本届客户栏会显示<i
              style="font-size: 20px; color: #52c41a; font-weight: bold"
              class="el-icon-check"
            ></i>
          </p>
          <p class="red">
            2、如不进行再次邀请操作，主办方将不为往届客户制作胸卡，请务必确认
          </p>
          <p class="red">3、本届新增客户无需进行二次确认</p>
        </div>
        <div class="badge-title">
          <div>客户胸卡列表</div>
          <div v-if="isShowBtn" class="create-wrap">
            <el-upload
              :action="$fileUrlImportCustomerBadge"
              :headers="headers"
              :multiple="false"
              :on-success="handleFileSuccess"
              :before-upload="beforeFileUpload"
              :on-error="handleFileError"
              :show-file-list="false"
            >
              <div class="badge-create badge-bg">上传导入模板</div>
            </el-upload>
            <a
              class="badge-create badge-bg"
              href="/uploads/badge/客户申请胸卡信息导入示例.xls"
              download="客户申请胸卡信息导入示例.xls"
              >下载批量导入模板</a
            >
            <div class="badge-create" @click="edit('')">创建客户胸卡</div>
          </div>
        </div>
        <div class="badge-search">
          <div class="search-item">
            <p>本届客户</p>
            <el-select
              v-model="search.is_customer"
              clearable
              placeholder="请选择"
            >
              <el-option
                v-for="item in options"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </div>
          <div class="search-item">
            <p>姓名</p>
            <el-input v-model="search.nickname" placeholder="请填写"></el-input>
          </div>
          <div class="search-item">
            <p>手机</p>
            <el-input v-model="search.tel" placeholder="请填写"></el-input>
          </div>
          <div class="search-item search-btn-wrap">
            <div class="search-btn" @click="searchHandle">搜索</div>
          </div>
        </div>

        <!-- 胸卡列表 -->
        <div class="badge-table">
          <el-table
            ref="multipleTable"
            :data="tableData"
            tooltip-effect="dark"
            style="width: 100%"
            @selection-change="handleSelectionChange"
          >
            <el-table-column type="selection" width="55" fixed="left">
            </el-table-column>
            <el-table-column label="ID" prop="id" width="70"></el-table-column>
            <el-table-column label="本届客户" width="80">
              <template slot-scope="scope">
                <div class="icon-wrap">
                  <i
                    v-if="scope.row.is_customer == 0"
                    class="el-icon-close"
                  ></i>
                  <i
                    v-if="scope.row.is_customer == 1"
                    class="el-icon-check"
                  ></i>
                </div>
              </template>
            </el-table-column>
            <el-table-column
              label="姓名"
              prop="nickname"
              min-width="120"
            ></el-table-column>
            <el-table-column
              label="公司名称"
              prop="company"
              min-width="200"
            ></el-table-column>
            <el-table-column
              label="部门"
              prop="department"
              width="120"
            ></el-table-column>
            <el-table-column
              label="职位"
              prop="position"
              width="120"
            ></el-table-column>
            <el-table-column
              label="手机"
              prop="tel"
              min-width="120"
            ></el-table-column>
            <el-table-column
              label="电子邮箱"
              prop="email"
              min-width="180"
            ></el-table-column>
            <el-table-column
              label="添加时间"
              prop="inputtime"
              min-width="180"
            ></el-table-column>
            <el-table-column label="操作" min-width="120" fixed="right">
              <template slot-scope="scope">
                <span class="check-btn" @click="edit(scope.row)">查看</span> |
                <span
                  class="check-btn check-del"
                  @click="del(scope.$index, scope.row)"
                  >删除</span
                >
              </template>
            </el-table-column>
          </el-table>
          <div class="pagination_box">
            <el-pagination
              background
              @current-change="handleCurrentChange"
              :current-page.sync="search.page_no"
              :page-size="search.page_size"
              layout="total, prev, pager, next"
              :total="totals"
            >
            </el-pagination>
          </div>
        </div>
        <div class="pagination_btn_wrap" v-if="isShowBtn">
          <div
            class="pagination_btn"
            @click="badgeMoreHandle('is_customer', 1)"
          >
            批量设定本届客户
          </div>
        </div>
      </div>
      <!-- 胸卡详情 -->
      <el-dialog
        :title="badgeId ? '编辑客户胸卡' : '添加客户胸卡'"
        :visible.sync="drawerEditMask"
        width="40%"
      >
        <div class="badge-details">
          <el-form
            :model="ruleForm"
            :rules="rules"
            ref="ruleForm"
            label-width="100px"
            label-position="right"
            class="demo-ruleForm"
          >
            <el-form-item label="姓名" prop="nickname">
              <el-input v-model="ruleForm.nickname"></el-input>
            </el-form-item>
            <el-form-item label="公司名称" prop="company">
              <el-input v-model="ruleForm.company"></el-input>
            </el-form-item>
            <el-form-item label="部门" prop="department">
              <el-input v-model="ruleForm.department"></el-input>
            </el-form-item>
            <el-form-item label="职位" prop="position">
              <el-input v-model="ruleForm.position"></el-input>
            </el-form-item>
            <el-form-item label="手机" prop="tel">
              <el-input v-model="ruleForm.tel"></el-input>
            </el-form-item>
            <el-form-item label="电子邮箱" prop="email">
              <el-input v-model="ruleForm.email"></el-input>
            </el-form-item>
          </el-form>
        </div>
        <span slot="footer" class="dialog-footer">
          <el-button @click="drawerEditMask = false">取 消</el-button>
          <el-button type="primary" @click="submitForm('ruleForm')"
            >确 定</el-button
          >
        </span>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import {
  customerBadgeList,
  delCustomerBadge,
  editcustomerBadge,
  customerBadgeDetail,
  addCustomerBadge,
  customerBadgeUpdBoolean,
} from "@/api/api";
import top from "../components/top.vue"; //头部
import navMenu from "../components/navMenu.vue"; //左侧步骤条
export default {
  components: { top, navMenu },
  name: "badgeList",
  data() {
    return {
      loading: false,
      active: 3,
      tableData: [],
      totals: 0,
      search: {
        is_customer: "", //是否本届客户
        nickname: "",
        tel: "",
        page_no: 1,
        page_size: 10,
      },
      options: [
        {
          value: "1",
          label: "是",
        },
        {
          value: "0",
          label: "否",
        },
      ],
      badgeCount: "", // 已填写胸卡数
      badge_num: "", // 胸卡名额数
      vipCount: "", //  已填写VIP数
      vip_num: "", //  VIP名额数
      drawerEditMask: false,
      badgeId: "",
      ruleForm: {
        nickname: "",
        company: "",
        department: "",
        position: "",
        tel: "",
        email: "",
      },
      rules: {
        nickname: [{ required: true, message: "请输入姓名", trigger: "blur" }],
        company: [
          { required: true, message: "请输入公司名称", trigger: "blur" },
        ],
        department: [
          { required: true, message: "请输入部门", trigger: "blur" },
        ],
        position: [{ required: true, message: "请输入职位", trigger: "blur" }],
        tel: [
          { required: true, message: "请输入手机", trigger: "blur" },
          {
            pattern: /^1[3-9]\d{9}$/,
            message: "手机号码格式不正确",
            trigger: "blur",
          },
        ],
        email: [
          { required: true, message: "请输入电子邮箱", trigger: "blur" },
          {
            type: "email",
            message: "请输入正确的邮箱地址",
            trigger: ["blur", "change"],
          },
        ],
      },
      isShowBtn: true,
      multipleSelection: [],
      headers: {},
    };
  },
  mounted() {
    let stepMenuList = JSON.parse(localStorage.getItem("menu"));
    this.stepMenuList = stepMenuList;
    var index = stepMenuList.findIndex(function (item) {
      return item.link_url == "conference" && item.id == 11;
    });
    this.active = index;
    let token = localStorage.getItem("token");
    this.headers = {
      token: token,
    };
    this.mark = this.$route.query.mark;
    this.getBadgeList();
  },
  created() {},
  methods: {
    // 返回
    goBack() {
      this.$router.back();
    },
    //搜索
    searchHandle() {
      this.getBadgeList();
    },
    //获取展商胸卡列表
    getBadgeList() {
      this.loading = true;
      let data = this.$qs.stringify(this.search);
      customerBadgeList(data)
        .then((res) => {
          //console.log(res, "=<======res");
          if (res.data.code == 1) {
            let { data } = res.data;
            this.badgeCount = data.badgeCount;
            this.badge_num = data.badge_num;
            this.vipCount = data.vipCount;
            this.vip_num = data.vip_num;
            this.totals = data.count;
            this.tableData = data.lists;
            this.isShowBtn = data.badge_btn_display == 1 ? true : false;
            this.loading = false;
          }
        })
        .catch((err) => {});
    },
    //多选
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    // 编辑
    edit(row) {
      this.drawerEditMask = true;
      if (row) {
        this.badgeId = row.cusbadge_long_id;
        this.getBadgeDetail(row.cusbadge_long_id);
      } else {
        this.badgeId = "";
        this.ruleForm.cusbadge_long_id = "";
        this.ruleForm.nickname = "";
        this.ruleForm.company = "";
        this.ruleForm.department = "";
        this.ruleForm.position = "";
        this.ruleForm.tel = "";
        this.ruleForm.email = "";
      }
    },
    //下载模版
    down(path) {},
    //胸卡详情
    getBadgeDetail(id) {
      let data = this.$qs.stringify({
        cusbadge_long_id: id,
      });
      customerBadgeDetail(data)
        .then((res) => {
          //console.log(res, "=<======res");
          if (res.data.code == 1) {
            let { data } = res.data;
            this.ruleForm.cusbadge_long_id = data.cusbadge_long_id;
            this.ruleForm.nickname = data.nickname;
            this.ruleForm.company = data.company;
            this.ruleForm.department = data.department;
            this.ruleForm.position = data.position;
            this.ruleForm.tel = data.tel;
            this.ruleForm.email = data.email;
          }
        })
        .catch((err) => {});
    }, // 删除
    del(index, row) {
      this.$alert(`确定要删除吗？`, "", {
        confirmButtonText: "确定",
        callback: (action) => {
          if (action == "confirm") {
            delCustomerBadge({ cusbadge_long_id: row.cusbadge_long_id })
              .then((res) => {
                if (res.data.code == 1) {
                  this.tableData.splice(index, 1);
                  this.totals = this.totals - 1;
                  this.$message.success(res.data.message);
                }
              })
              .catch((err) => {
                console.log(err, "===err");
              });
          }
        },
      });
    },
    // 分页相关
    handleCurrentChange(val) {
      this.search.page_no = val;
      this.getBadgeList();
    },
    //胸卡详情保存
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          if (this.ruleForm.cusbadge_long_id) {
            this.saveEditBadge();
          } else {
            this.saveAddBadge();
          }
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    //编辑胸卡详情
    saveEditBadge() {
      let data = this.ruleForm;
      data.mark = this.mark;
      editcustomerBadge(data)
        .then((res) => {
          if (res.data.code == 1) {
            this.$message.success(res.data.msg);
            this.search.page_no = 1;
            this.getBadgeList();
            this.drawerEditMask = false;
          } else {
            this.$message.warning(res.data.msg);
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    //添加胸卡
    saveAddBadge() {
      let data = this.ruleForm;
      data.mark = this.mark;
      addCustomerBadge(data)
        .then((res) => {
          if (res.data.code == 1) {
            this.$message.success(res.data.msg);
            this.search.page_no = 1;
            this.getBadgeList();
            this.drawerEditMask = false;
          } else {
            this.$message.warning(res.data.message);
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    //批量设置胸卡
    badgeMoreHandle(type, val) {
      if (this.multipleSelection.length == 0) {
        this.$message.warning("您未选中任何项！");
        return false;
      }
      let select = this.multipleSelection
        .filter((item) => item.cusbadge_long_id)
        .map(({ cusbadge_long_id }) => cusbadge_long_id);
      select = select.join(",");
      customerBadgeUpdBoolean({
        field: type,
        val,
        ids: select,
      })
        .then((res) => {
          if (res.data.code == 1) {
            this.$message.success(res.data.msg);
            this.getBadgeList();
          } else {
            this.$message.warning(res.data.msg);
          }
        })
        .catch((err) => {});
    },
    beforeFileUpload() {
      this.loading = true;
    },
    //文件上传成功
    handleFileSuccess(resData, file, fileList) {
      this.loading = false;
      if (resData.code == 1) {
        this.$alert(resData.data.msg, "", {
          confirmButtonText: "确定",
          callback: (action) => {
            if (action == "confirm") {
            }
          },
        });
        this.getBadgeList();
      } else {
        this.$alert(resData.data.msg, "", {
          confirmButtonText: "确定",
          callback: (action) => {
            if (action == "confirm") {
            }
          },
        });
      }
    },
    //文件上传失败
    handleFileError(err, file, fileList) {
      this.$alert(err.message, "", {
        confirmButtonText: "确定",
        callback: (action) => {
          if (action == "confirm") {
          }
        },
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.badge-content {
  margin-bottom: 0;
  .badge-title {
    font-weight: 500;
    font-size: 16px;
    color: #354052;
    line-height: 24px;
    padding: 20px 0 30px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    .create-wrap {
      display: flex;
    }
    .badge-create {
      min-width: 103px;
      height: 36px;
      color: #fff;
      font-size: 14px;
      text-align: center;
      line-height: 36px;
      cursor: pointer;
      border-radius: 4px;
      margin-left: 10px;
      padding: 0 10px;
      box-sizing: border-box;
      background: linear-gradient(270deg, #fe4d34 0%, #fc933f 100%);
    }
    .badge-bg {
      background: #fc933f;
    }
  }
  .badge-tips {
    font-size: 14px;
    color: #1d1d1d;
    line-height: 22px;
    padding: 20px;
    background: #fff;
    border-radius: 10px;
    margin-top: 20px;
    .red {
      color: #ff4d4f;
    }
  }
  .badge-search {
    display: flex;
    flex-wrap: wrap;
    align-items: end;
    padding: 20px;
    background: #fff;
    border-radius: 10px;
    .search-item {
      width: 30%;
      font-size: 14px;
      color: #7f8fa4;
      line-height: 22px;
      margin-right: 24px;
      margin-bottom: 10px;
      p {
        margin-bottom: 7px;
      }
      .el-select {
        width: 100%;
      }
    }
    .search-btn-wrap {
      width: calc(90% + 48px);
      display: flex;
      justify-content: end;
    }
  }
  .search-btn {
    width: 103px;
    height: 38px;
    color: #fff;
    font-size: 14px;
    line-height: 38px;
    text-align: center;
    background: #fc933f;
    border-radius: 3px;
    cursor: pointer;
  }
  .badge-table {
    padding: 20px 0;
    .el-table {
      border-radius: 10px;
      /deep/ .el-table__body-wrapper {
        min-height: 300px;
      }
    }
    .icon-wrap {
      font-size: 20px;
      .el-icon-close {
        color: #eb4141;
        font-weight: bold;
      }
      .el-icon-check {
        color: #52c41a;
        font-weight: bold;
      }
    }
    .check-btn {
      color: #3d83e9;
      cursor: pointer;
      font-weight: 500;
    }
    .check-btn:hover {
      text-decoration: underline;
    }
    .check-del {
      color: #ff4d4f;
    }
    .pagination_box {
      display: flex;
      align-items: center;
      justify-content: right;
      margin-top: 50px;
    }
  }
  .pagination_btn_wrap {
    display: flex;
    flex-wrap: wrap;
    position: fixed;
    bottom: 20px;
    z-index: 99;
    .pagination_btn {
      color: #fff;
      height: 32px;
      font-size: 14px;
      cursor: pointer;
      line-height: 32px;
      padding: 0 12px;
      border-radius: 4px;
      background: #3d83e9;
      margin-top: 10px;
      margin-right: 10px;
    }
  }
}
.badge-details {
  // padding: 0 30px;
  .details-title {
    font-size: 16px;
    font-weight: 500;
    color: #3d83e9;
    padding-bottom: 20px;
    border-bottom: 1px solid #3d83e9;
  }
  .demo-ruleForm {
    padding: 10px 70px 10px 0;
  }
}
.el-table--striped .el-table__body tr.el-table__row--striped td {
  background: #fff;
}
/deep/ .el-table td,
/deep/ .el-table th.is-leaf {
  border-bottom: 0 none;
}
/* 表格最外层边框-底部边框 */
/deep/ .el-table--border::after,
/deep/ .el-table--group::after {
  width: 0;
}
/deep/ :focus {
  outline: 0;
}
/deep/ .el-drawer__header {
  font-size: 18px;
  color: #333;
  font-weight: 500;
}
@media only screen and (max-width: 1060px) {
  .badge-content .badge-search .search-item {
    width: 45%;
  }
  .badge-content .badge-search .search-btn-wrap {
    width: 45%;
    justify-content: start;
  }
}
@media only screen and (max-width: 767px) {
  .content {
    margin: 0;
    padding: 20px;
  }
  .badge-content .badge-search .search-item {
    width: 100%;
    margin-right: 0;
  }
  .badge-content .badge-table .pagination_box .pagination_left {
    flex-wrap: wrap;
  }
  .badge-content .badge-table .pagination_box .pagination_left .pagination_btn {
    margin-bottom: 10px;
  }
  .pagination_box {
    flex-wrap: wrap;
    .el-pagination {
      width: 100%;
      padding: 20px 0;
      text-align: right;
    }
  }
  /deep/ .el-dialog {
    width: 90% !important;
  }
  .badge-details {
    padding: 0;
    .demo-ruleForm {
      padding: 0;
    }
  }
}
</style>